import { render, staticRenderFns } from "./audio-recorder.vue?vue&type=template&id=f5dcffbe"
import script from "./audio-recorder.vue?vue&type=script&lang=js"
export * from "./audio-recorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports